import getLowestPersonalizedPayment from '../getLowestPersonalizedPayment/getLowestPersonalizedPayment.js';

/**
 * Retrieves a personalized payment offer that matches the specified lender name.
 *
 * @param {Object} paymentDetails - The payment details object containing rates and offers.
 * @param {string} creditType - The type of credit (e.g., "excellent", "good", etc.).
 * @param {string|number} loanTerm - The loan term for which the payment offer is being retrieved.
 * @param {string} lenderName - The name of the lender to match against the `offeredBy` property.
 * @returns {Object} The matching personalized payment offer or an empty object if no match is found.
 */
const getPersonalizedPaymentByLender = (paymentDetails, creditType, loanTerm, lender) => paymentDetails?.rates?.[creditType]?.paymentOffers?.[loanTerm]?.find(offer => offer.offeredBy === lender) ?? paymentDetails?.rates?.[creditType]?.nationalOffers?.[loanTerm]?.find(offer => offer.offeredBy === lender) ?? getLowestPersonalizedPayment(paymentDetails, creditType, loanTerm);
export { getPersonalizedPaymentByLender as default };
